import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    api: 'KO',
    auth: {
      admin: false,
      editor: false,
      calendar: false
    },
    currentJwt: ''
  },
  getters: {
    jwt: state => state.currentJwt,
    jwtData: (state, getters) => state.currentJwt ? JSON.parse(atob(getters.jwt.split('.')[1])) : null,
    jwtSubject: (state, getters) => getters.jwtData ? getters.jwtData.sub : null,
    jwtIssuer: (state, getters) => getters.jwtData ? getters.jwtData.iss : null
  },
  mutations: {
    setJwt (state, jwt) {
      state.currentJwt = jwt
    },
    updateApi (state, apiState) {
      state.api = apiState ? 'OK' : 'KO'
    },
    updateAuth (state, auth) {
      state.auth = auth
    }
  }
})



// WEBPACK FOOTER //
// ./src/services/store.js